import { getUserLanguage } from '@/redux/user/selectors';
import { connect } from 'react-redux';
import CSS from './Home.module.css';
import { Images } from '@/assets/images';
import type { Langs } from '@CS/components/TranslationProvider/types';
import Content from './content';
import { useTranslation } from '@CS/hooks';
import SearchButton from '@/components/SearchButton';
import { MCD } from '@/services/app';

type HomeProps = {
  lang?: Langs;
};

const Home = ({ lang }: HomeProps) => {
  const title = useTranslation(Content.title);
  const text = useTranslation(Content.text);
  const bookPartyLabel = useTranslation(Content.bookPartyButton.label);

  const handleSearch = async () => {
    try {
      await MCD.openRestaurantFinder();
    } catch (error) {
      console.error('Error opening restaurant finder:', error);
    }
  };

  const handleBookParty = () => {
    const url = lang === 'en' ? Content.bookPartyButton.url.en : Content.bookPartyButton.url.ar;
    location.href = url;
  };

  return (
    <main className={CSS.homeScreen + ' ' + CSS.fadeIn} aria-label="Home">
      <img
        src={lang === 'en' ? Images.LogoEnglish : Images.LogoArabic}
        alt="Logo"
        className={CSS.logo}
      />

      <section
        className={CSS.content}
        style={lang === 'en' ? { direction: 'ltr' } : { direction: 'rtl' }}
      >
        <img src={Images.Ball} alt="Ball" className={CSS.ball} />
        <h1 className={CSS.title}>{title}</h1>
        <p className={CSS.text}>{text}</p>
        <SearchButton onClick={handleSearch} />
        <button className={CSS.bookButton} onClick={handleBookParty}>
          {bookPartyLabel}
        </button>

      </section>
    </main>
  );
};

const mapStateToProps = (state: never) => ({
  lang: getUserLanguage(state)
});

export default connect(mapStateToProps)(Home);
